import { useCallback, useRef, useState } from 'react';
import _debounce from 'lodash/debounce';

import useEventListener from './useEventListener';

const DEBOUNCE_DELAY = 300;

const useClientSize = () => {
  const [dimensions, setDimensions] = useState({
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight
  });

  const dimensionsRef = useRef(dimensions);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleResize = useCallback(
    _debounce(
      () => {
        const { clientWidth, clientHeight } = document.documentElement;
        const { width, height } = dimensionsRef.current;
        if (width !== clientWidth || height !== clientHeight) {
          const newDimensions = {
            width: clientWidth,
            height: clientHeight
          };
          setDimensions(newDimensions);
          dimensionsRef.current = newDimensions;
        }
      },
      DEBOUNCE_DELAY,
      { leading: true }
    ),
    []
  );

  // eslint-disable-next-line i18next/no-literal-string
  useEventListener(['resize', 'scroll'], handleResize);

  return dimensions;
};

export default useClientSize;
